// src/footer/MenuFooter.jsx
import './menufooter.css';
import { Link } from 'react-router-dom';
import logo from '../header/images/logo.png';

const MenuFooter = () => {
  return (
    <footer className="menufooter">
      <div className="menufooter__container">

        {/* LOGO */}
        <div className="menufooter__logo-box">
          <Link to="/">
            <img src={logo} alt="ContaLearn" className="menufooter__logo" />
          </Link>
        </div>

        {/* BUTOANE */}
        <div className="menufooter__buttons">
          <Link to="/" className='link-footer-menu'>
            <div className='design-butonm-menu-footer'>Home</div>
          </Link>
        </div>
      </div>
      <div className='line-under-menu-footer'></div>
    </footer>
  );
};

export default MenuFooter;
